module.exports = __webpack_public_path__ + "img/water-rat-wake.a208e6ef8523ea3665b0116fbc0b15a4.jpg";